// extracted by mini-css-extract-plugin
module.exports = {"divider":"bar-module--divider--1m2i2","subtitle":"bar-module--subtitle--3yxKx","text":"bar-module--text--4GJcA","container":"bar-module--container--2C7_F"};